/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinalizeProjectResponse } from '../../models/finalize-project-response';

export interface ProjectsControllerFinalizeProject$Params {

/**
 * Project id.
 */
  id: string;
}

export function projectsControllerFinalizeProject(http: HttpClient, rootUrl: string, params: ProjectsControllerFinalizeProject$Params, context?: HttpContext): Observable<StrictHttpResponse<FinalizeProjectResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerFinalizeProject.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinalizeProjectResponse>;
    })
  );
}

projectsControllerFinalizeProject.PATH = '/planning-projects/v1/projects/{id}/finalize';
